export const SET_SPONSOR = 'SPONSOR/SET_SPONSOR'
export const SET_SPONSORS = 'SPONSOR/SET_SPONSORS'
